import { render, staticRenderFns } from "./HotelsTable.vue?vue&type=template&id=6af89b23"
import script from "./HotelsTable.vue?vue&type=script&lang=js"
export * from "./HotelsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports